/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { BehaviorSubject } from 'rxjs';

/**
 * The goal of this class is to provide a "es6 singleton" instance of itself, with the ability to register and provide "very global"
 * angular services to code unable to access the angular injector (non-angular code).
 * When in "real app" mode, this service will be initialized by [[AngularExporter]].
 * When in "unit testing" mode, you are expected to call init when/ if you need it. See the [[SplitData]] spec file for an example.
 */
export class ExternalAngulars {
	private loadedSubject = new BehaviorSubject(false);
	public loaded$ = this.loadedSubject.asObservable();
	public loadedSync = false;
	public featureFlagManager: FeatureFlagManager;

	public init(featureFlagManager: FeatureFlagManager) {
		this.featureFlagManager = featureFlagManager;

		this.loadedSubject.subscribe((load) => (this.loadedSync = load));

		this.loadedSubject.next(true);
	}
}

/** Singleton instance, this is the one you'll want to use... 99% of the time */
export const externalAngulars = new ExternalAngulars();
